export default __webpack_public_path__ + "static/media/IMG_0008_16_11zon.6dc2c3dd.jpg";